import styled from "@emotion/styled";
import { TERTIARY_GREY, READY_TO_SUBMIT_BG } from "src/constants/colors";
import { Button, type ButtonProps } from "./ButtonsTemp";

export const AlertContainer = styled.div<{ isVisible: boolean }>`
  max-height: ${({ isVisible }) => (isVisible ? "200px" : "0")};
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  transform: ${({ isVisible }) =>
    isVisible ? "translateY(0)" : "translateY(-20px)"};
  transition:
    opacity 0.3s ease,
    transform 0.3s ease,
    max-height 0.3s ease,
    margin-bottom 0.3s ease;
  overflow: hidden;
`;

export const AlertFrame = styled.div`
  background-color: ${READY_TO_SUBMIT_BG};
  border-radius: 28px;
  padding: 16px;
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const AlertContent = styled.div`
  background-color: white;
  border-radius: 16px;
  padding: 20px 16px;
  display: flex;
  align-items: flex-start;
  gap: 16px;
  position: relative;
  box-shadow:
    0 1px 4px -0.5px rgba(0, 0, 0, 0.03),
    0 3px 3px -1.5px rgba(0, 0, 0, 0.03),
    0 20px 20px -12px rgba(0, 0, 0, 0.03),
    0 32px 32px -16px rgba(0, 0, 0, 0.03),
    0 56px 56px -28px rgba(0, 0, 0, 0.03);
`;

export const IconCircle = styled.div`
  width: 34px;
  height: 34px;
  border-radius: 17px;
  background-color: #f4f1ee;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const TextContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Title = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #111827;
  line-height: 1.25;
  padding-right: 30px;
`;

export const Description = styled.div`
  font-size: 12px;
  color: #4a5466;
  line-height: 1.3333;
`;

export const CloseButton = styled(Button)<ButtonProps & { size: "icon" }>`
  position: absolute;
  right: 12px;
  top: 12px;
`;

export const Footer = styled.div`
  font-size: 10px;
  color: ${TERTIARY_GREY};
  line-height: 13px;
  text-align: center;
  color: #8c6727;
`;
